var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H15.3373C15.5818 4 15.7041 4 15.8192 4.02763C15.9213 4.05213 16.0188 4.09253 16.1083 4.14736C16.2092 4.2092 16.2957 4.29568 16.4686 4.46863L20.5314 8.5314C20.7043 8.7043 20.7908 8.7908 20.8526 8.8917C20.9075 8.9812 20.9479 9.0787 20.9724 9.1808C21 9.2959 21 9.4182 21 9.6627V12.5C21 12.9659 21 13.1989 20.9239 13.3827C20.8224 13.6277 20.6277 13.8224 20.3827 13.9239C20.1989 14 19.9659 14 19.5 14M14.5 14H13M13 14V4.2C13 3.0799 13 2.51984 12.782 2.09202C12.5903 1.71569 12.2843 1.40973 11.908 1.21799C11.4802 1 10.9201 1 9.8 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.0799 1 4.2V12C1 13.1046 1.89543 14 3 14M13 14H9M3 14C3 15.6569 4.34315 17 6 17C7.65685 17 9 15.6569 9 14M3 14C3 12.3431 4.34315 11 6 11C7.65685 11 9 12.3431 9 14M19.5 14.5C19.5 15.8807 18.3807 17 17 17C15.6193 17 14.5 15.8807 14.5 14.5C14.5 13.1193 15.6193 12 17 12C18.3807 12 19.5 13.1193 19.5 14.5Z",
    stroke: "#3C3C43",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.bb25ec96ee3f6b781738fc2cef198f00.svg";
export { ForwardRef as ReactComponent };